import { Row, Col } from 'react-bootstrap';
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';
import ReplyIcon from './icons/ReplyIcon';

function ReplyContainer(props) {
  const { data, scrollToComment, setCommentToReplyId, handleClose } = props

  return (
    <div
      className="message message--reply"
      onClick={() => scrollToComment && scrollToComment(data.id) }
    >
      <div className="d-flex justify-content-between align-items-center">
        {
          handleClose == undefined &&
          <ReplyIcon />
        }
        <div style={{width: '95%'}} className="px-2">
          <div className="user">
            { data?.user?.full_name }
          </div>
          {
            data.description &&
            <div className= "comment-to-reply-container">
              <div className="description_html" dangerouslySetInnerHTML={{ __html:
                linkifyHtml((data.description || ''), { target: '_blank' })
              }} />
            </div>
          }

          {
            data.attachments?.length > 0 &&

            <span>
              {`${data.attachments.length} attachment${data.attachments.length >= 2 ? 's' : ''}`}
            </span>

          }
        </div>

        {
          handleClose &&

            <div
              className="d-flex p-0"
            >
                <i className="fa fa-times m-auto " aria-hidden="true" onClick={handleClose}></i>
            </div>
        }
      </div>
    </div>
  );
}

export { ReplyContainer };
